<div
  class="wrapper--slider"
  #slider
  (touchstart)="knobDragStart($event)"
  (mousedown)="knobDragStart($event)"
  [ngClass]="{ 'opacity-25': !hasCommitted && levelDisplay === 0 }"
>
  <div class="bar" #bar>
    <div
      class="fill--current {{ fillColor }}"
      [style.left]="currentLeft"
      [style.width]="max ? max : fillCurrentLevel"
    ></div>
    <div
      class="notch"
      *ngIf="showKnob && !hasCommitted"
      #notch
      [style.left]="notchValue"
    ></div>
  </div>
  <div
    class="knob"
    #knob
    *ngIf="showKnob"
    [ngClass]="{ active: knobDragActive }"
    [style.transform]="'translateX(' + knobPositionX + 'px)'"
  >
    <div class="knob--data" [class.text-hidden]="textHidden">
  <ng-container *ngIf="checkmarkShown; else levelTpl">
    <ark-lib-icon-name name="tick" class="pointer-events-none"></ark-lib-icon-name>
  </ng-container>
  <ng-template #levelTpl>
    {{ levelDisplay }}
  </ng-template>
</div>
  </div>
  <div class="point">{{ activePoint?.label }}</div>

   <div class="relative w-full mt-1">
  <div
    *ngFor="let n of [].constructor(11); let i = index"
    class="absolute text-xs font-medium text-[#9A948C] text-center"
    [style.left]="(i * 10) + '%'"
    [style.transform]="i === 0 ? 'translateX(0%)' : (i === 10 ? 'translateX(-100%)' : 'translateX(-100%)')"
  >
    {{ i }}
  </div>
</div>
</div>
